//记得在 src\components\lang\zhLoad.js 里面添加对象
const taskList = {
  taskId:'任务包ID',
  taskName: '任务名称',
  taskType: '任务类型',
  region: '大区',
  applicableArea: '适用区域',
  taskCycle: '任务周期',
  claimed: '已领取',
  status: '状态',
  homefeed:'首页推送',
  homeRankings: '首页排行',
  taskPkgMustFlag: '是否必做',
  taskBeginDate: '任务开始时间',
  taskEndDate: '任务结束时间',
  taskPoints: '任务积分',
  taskDescription: '任务描述',
  taskImage: '任务相关图片',
  creatorName: '创建人',
  msg: {}
};
export default taskList



// WEBPACK FOOTER //
// ./src/page/taskManagement/taskList/lang/taskList.zh.js